import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { ConfigProvider } from "antd";
import { AuthProvider } from "State/AuthContext";
import { JobDataProvider } from "State/JobsDataContext";
import { EmployeeSkillsProvider } from "State/EmployeeSkillsContext";
import { PAICProjectProvider } from "State/PAICProjectContext";
import { Provider } from "react-redux";
import store from "Store/store";
import "App.css";
import "styles.scss";

import ProtectedRoutesV2 from "Routes/ProtectedRoutesV2";
import { SB_ANT_THEME, SB_STYLED_THEME, SbGlobalFonts } from "theme/SbThemeV2";
import useGlobalSSE from "Hooks/useGlobalSSE";

// Mounts the global SSE listener once inside AuthProvider.
// Reads accessToken from useAuthStore (Zustand) — not AuthContext —
// so it only reacts to actual token changes, not unrelated context re-renders.
const GlobalSSEMount = () => {
  useGlobalSSE();
  return null;
};

/**
 * RouteSelector
 *
 * V2 (Ant Design) is now the only UI version.
 * Always renders ProtectedRoutesV2.
 */
const RouteSelector = () => {
  return <ProtectedRoutesV2 />;
};

function App() {
  return (
    <Router>
      <Provider store={store}>
        <AuthProvider>
          <GlobalSSEMount />
          <JobDataProvider>
            <EmployeeSkillsProvider>
              <PAICProjectProvider>
                {/*
                  ThemeProvider: supplies SB_STYLED_THEME to all styled-components.
                  ConfigProvider: applies SB_ANT_THEME tokens to all Ant Design components.
                  Both are present at the root so V1 and V2 share the same theme source.
                  The primary brand color #008080 is enforced here.
                */}
                {/*
                  ThemeProvider: supplies SB_STYLED_THEME to all styled-components.
                  ConfigProvider: applies SB_ANT_THEME tokens to all Ant Design components.
                  The primary brand color #008080 is enforced here.
                */}
                <ThemeProvider theme={SB_STYLED_THEME}>
                  <SbGlobalFonts />
                  <ConfigProvider theme={SB_ANT_THEME}>
                    <RouteSelector />
                  </ConfigProvider>
                </ThemeProvider>
              </PAICProjectProvider>
            </EmployeeSkillsProvider>
          </JobDataProvider>
        </AuthProvider>
      </Provider>
    </Router>
  );
}

export default App;
